import React from 'react';
import styled from 'styled-components';

import theme from '../../theme';

const GroupBoxContainer = styled.div`
  position: relative;
  /* margin-top: 1rem; */
`;

const GroupBoxTitle = styled.div`
  font-size: 0.85rem;
  font-weight: 500;
  color: ${theme.colors.botaoConfirmar};
  margin-bottom: 5px;
`;

const GroupBoxList = styled.div`
  border: 1px solid #cbd5e0;
  border-radius: 12px;
  background-color: #f8f9fa;
  padding: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

interface Props {
  title: string;
  children: React.ReactNode;
}

const CheckBoxGroupBox: React.FC<Props> = ({ title, children }) => {
  return (
    <GroupBoxContainer>
      <GroupBoxTitle>{title}</GroupBoxTitle>
      <GroupBoxList>{children}</GroupBoxList>
    </GroupBoxContainer>
  );
};

export default CheckBoxGroupBox;
